import { memo } from 'react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './ValueSurvey.module.scss';

const items = [
  { key: 'gender', value: 79 },
  { key: 'friends', value: 74 },
  { key: 'notathletic', value: 72 },
  { key: 'age', value: 70 },
];

export const ValueSurvey: FC = memo(function ValueSurvey() {
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <h4 className={classes.heading}>{t('about:survey.heading')}</h4>

      <ul className={classes.list}>
        {items.map(({ key, value }) => (
          <li className={classes.item} key={key}>
            <div className={classes.itemHead}>
              <span className={classes.label}>{t(`about:survey.${key}`)}</span>
              <span className={classes.value}>{value}<span className={classes.unit}>%</span></span>
            </div>
            <div className={classes.track}>
              <div className={classes.fill} style={{ width: `${value}%` }} />
            </div>
          </li>
        ))}
      </ul>
      <small className={classes.amendment}>{t('about:survey.amendment')}</small>
    </div>
  );
});
